import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn
} from 'material-ui/Table';

import ListActionItems from '../../List/ListActionItems';
import List from '../../List/List';
import AddButton from './../../AddButton';
import LoadMore from '../../LoadMore';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import LoadingSpinner from '../../LoadingSpinner';
import IconCheckBox from '../../Icons/IconCheckBox';
import IconCheckBoxChecked from '../../Icons/IconCheckBoxChecked';
import NameFormatter from '../../NameFormatter';

class NewsList extends List {
  static contextTypes = {
    muiTheme: React.PropTypes.object
  };

  constructor() {
    super();
    this.confirmRemoveMessage = (
      <FormattedMessage
        id="fanBoxMessage.remove"
        defaultMessage="Are you sure you want to delete news?"
      />
    );
  }

  render() {
    let { add, list, items, hasMore, loading } = this.props;
    let {palette: {labelColor}, tableHeaderColumn} = this.context.muiTheme;
    let records = list.map(id => items[id]);
    let fixedColumn = {style: {width: 120, color: labelColor}};

    return (
      <div>
        <LoggedAppBar title="News" isStatic/>
        <LoadingSpinner show={loading}>
            <LoadMore active={hasMore} loadMore={() => this.loadMore()}>
              <Table selectable={false}>
                <TableHeader adjustForCheckbox={false} displaySelectAll={false} enableSelectAll={false}
                             style={{
                               backgroundColor: tableHeaderColumn.bgColor
                             }}
                >
                  <TableRow>
                    <TableHeaderColumn {...fixedColumn}>Published</TableHeaderColumn>
                    <TableHeaderColumn style={{color: labelColor}}>Author</TableHeaderColumn>
                    <TableHeaderColumn style={{color: labelColor}}>Subject</TableHeaderColumn>
                    <TableHeaderColumn {...fixedColumn}>Creation date</TableHeaderColumn>
                    <TableHeaderColumn {...fixedColumn}>Published date</TableHeaderColumn>
                    <TableHeaderColumn {...fixedColumn}>Options</TableHeaderColumn>
                  </TableRow>
                </TableHeader>

                <TableBody displayRowCheckbox={false}>
                  {records.length > 0
                    ? records.map(({id, title, published, createDate, publishDate, createdBy}) => (
                    <TableRow key={id}>
                      <TableRowColumn {...fixedColumn}>
                        {published ? (<IconCheckBoxChecked/>) : <IconCheckBox/> }
                      </TableRowColumn>
                      <TableRowColumn>
                        <NameFormatter user={createdBy}></NameFormatter>
                      </TableRowColumn>
                      <TableRowColumn>{title}</TableRowColumn>
                      <TableRowColumn {...fixedColumn}>
                        <FormattedDate value={createDate}/>
                      </TableRowColumn>
                      <TableRowColumn {...fixedColumn}>
                        {publishDate ? (<FormattedDate value={publishDate}/>) : '-'}
                      </TableRowColumn>
                      <TableRowColumn {...fixedColumn}>
                        <ListActionItems edit={this.props.edit}
                                         remove={this.props.delete}
                                         record={items[id]}
                                         confirmMessageLabel={this.confirmRemoveMessage}
                        />
                      </TableRowColumn>
                    </TableRow>
                  ))
                    : (<TableRow><TableRowColumn columnNumber={6}>Empty list</TableRowColumn></TableRow>)
                  }
                </TableBody>
              </Table>
            </LoadMore>
        </LoadingSpinner>
        <AddButton onClick={add}/>
      </div>
    );
  }
}

export default NewsList;



// WEBPACK FOOTER //
// ./src/components/News/NewsList/NewsList.jsx